export const About = (props) => {
  return (
    <div id="about">
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-md-6">
            {" "}
            <img src="img/pswap_ph.png" className="img-responsive" alt="" />{" "}
          </div>
          <div className="col-xs-12 col-md-6">
            <div className="about-text">
              <h2>How To Buy</h2>
              <p>{props.data ? props.data.paragraph : "loading..."} {' '}
            <a href='https://pancakeswap.finance/swap' target='_blank' rel='noreferrer'>
             purchase Crisprcoin on PancakeSwap
            </a></p>
              <h4 onClick={() =>  navigator.clipboard.writeText('Available 2022')}
            ><i className='fa fa-copy'></i>&nbsp;Available Summer&nbsp;&frasl;&nbsp;Fall 2022</h4>
                
              <div className="list-style">
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                    {props.data
                      ? props.data.Why.map((d, i) => (
                          <li key={`${d}-${i}`}>{d}</li>
                        ))
                      : "loading"}
                  </ul>
                </div>
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                    {props.data
                      ? props.data.Why2.map((d, i) => (
                          <li key={`${d}-${i}`}> {d}</li>
                        ))
                      : "loading"}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};